import { useContext } from "react";
import { GlobalVars } from "./globalVars";
import { AuthContext } from "../../providers/AuthProvider";
import { NavLink } from "react-router-dom";

import UilEstate from "@iconscout/react-unicons/icons/uil-estate";
import UilSchedule from "@iconscout/react-unicons/icons/uil-schedule";
import UilChartPie from "@iconscout/react-unicons/icons/uil-chart-pie";
import UilTicket from "@iconscout/react-unicons/icons/uil-ticket";

export default function NavLinks({ mobile }) {
	const { roles } = useContext(AuthContext);

	const links = [
		{
			label: "Home",
			path: "/",
			icon: <UilEstate size={GlobalVars.iconSize.md} />
		},
		{
			label: "Schedule",
			path: "/schedule",
			icon: <UilSchedule size={GlobalVars.iconSize.md} />
		},
		{
			label: "Vetro",
			path: "/vetro",
			icon: <UilChartPie size={GlobalVars.iconSize.md} />
		},
		{
			label: "Kairos",
			path: "#", // Placeholder for external link
			icon: <UilTicket size={GlobalVars.iconSize.md} />,
			requiredRole: "dev",
			onClick: () => {
				// Get the auth token from sessionStorage
				const authData = JSON.parse(sessionStorage.getItem("authData"));

				if (!authData || !authData.accessToken) {
					alert("Authentication required. Please log in first.");
					window.location.href = "/auth/login";
					return;
				}

				// Redirect to Kairos with authentication token
				const kairosUrl =
					process.env.NODE_ENV === "production"
						? "http://crm.citysidefiber.com:667/"
						: "http://localhost:667";

				console.log("Redirecting to Kairos with authentication token");
				window.open(`${kairosUrl}?auth_token=${authData.accessToken}`, "_blank");
			}
		}
	];

	// Filter links based on user roles
	const visibleLinks = links.filter((link) => {
		if (link.label === "Kairos") {
			const normalizedRoles = Array.isArray(roles) ? roles : [];
			if (normalizedRoles.length === 0) return false; // hide for no-role users
			return !normalizedRoles.includes("contractor"); // hide for contractor role
		}
		if (!link.requiredRole) return true;
		return roles?.includes(link.requiredRole);
	});

	if (mobile) {
		return (
			<>
				{visibleLinks.map((link, index) => (
					<NavLink
						key={index}
						to={link.path}
						onClick={(e) => {
							if (link.onClick) {
								e.preventDefault();
								link.onClick();
							}
						}}
						style={{ boxShadow: 'none', filter: 'none' }}
						className={({ isActive }) =>
							`${
								(isActive && link.label !== "Hermes" && link.label !== "Kairos")
									? "bg-light-1/50 ring-2 ring-light-3 text-light-3"
									: "text-light-10"
							} flex items-center mb-1 p-4 hover:text-light-3 hover:bg-light-1/30 rounded transition duration-350 ease-in-out`
						}
						{...(link.path === "/" && { end: true })}
					>
						{link.icon}
					</NavLink>
				))}
			</>
		);
	} else {
		return (
			<>
				{visibleLinks.map((link, index) => (
					<NavLink
						key={index}
						to={link.path}
						onClick={(e) => {
							if (link.onClick) {
								e.preventDefault();
								link.onClick();
							}
						}}
						style={{ boxShadow: 'none', filter: 'none' }}
						className={({ isActive }) =>
							`${
								(isActive && link.label !== "Hermes" && link.label !== "Kairos")
									? "bg-light-1/60 text-light-11"
									: "text-light-10"
							} flex items-center p-4 mb-1 hover:text-light-11 hover:bg-light-1/40 transition ease-in-out duration-350 rounded`
						}
						{...(link.path === "/" && { end: true })}
					>
						{link.icon}
						<span className="ml-2">{link.label}</span>
					</NavLink>
				))}
			</>
		);
	}
}
